function MainText() {
    return (
        <div className='flex justify-center sm:justify-normal items-center sm:items-center lg:h-1/2 w-full ml-0 sm:ml-0 lg:w-full mt-16 sm:mt-0'>
            <h1 className='text-blue-950 text-2xl text-left sm:text-3xl md:text-4xl lg:text-7xl lg:mr-4 font-bold sm:ml-32 md:ml-20'>เราลองมาดูกันว่าสิ่งที่ชอบของคุณบ่งบอกถึงบุคลิกแบบไหน</h1>
        </div>
    )
}

export default MainText;